import {connect} from 'react-redux';
import Step14 from './Step14';
import {submitStep} from '../../actions/submitStep';
import {uploadFile} from '../../actions/uploadFile';
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";

const mapStateToProps = ({
                           regType: {regType},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  prevCompletedStepSign
});

export default connect(
  mapStateToProps,
  {submitStep, uploadFile, prevCompletedStepSignFalse}
)(Step14);
